<template>
  <div v-editable="blok" :class="marginClasses" class="flex w-full">
    <div
      v-if="blok && image"
      class="flex size-full"
      :class="[
        {
          'mx-break-out':
            (!cmsParentBlok || cmsParentBlok.component === 'BlogOverview') &&
            blok.wholeWidth,
        },
        {
          'justify-start': blok.horizontal_alignment === 'left',
          'justify-center': blok.horizontal_alignment === 'centered',
          'justify-end': blok.horizontal_alignment === 'right',
        },
        {
          'items-start': blok.vertical_alignment === 'top',
          'items-center': blok.vertical_alignment === 'centered',
          'items-end': blok.vertical_alignment === 'bottom',
        },
      ]"
    >
      <NuxtLazyImage
        :key="image.filename"
        :source="image.filename"
        :alt="blok.altDescription"
        :title="image.title ?? undefined"
        :no-scale="blok.doNotScale"
        :optimise-desktop="optimiseDesktop"
        :cover="cover"
        :lazy="lazy"
        :high-priority="!lazy"
        :image-class="imageClass"
      />

      <slot name="screenReaderDescription" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, getCurrentInstance } from 'vue'
import type { PropType } from 'vue'
import useStoryblokMargins from '~/cms/storyblok/composables/useStoryblokMargins'
import { useDeviceType } from '~/composables/useDeviceType'
import type {
  SbAssetImage,
  BaseStoryblokComponent,
} from '~/cms/storyblok/types/storyblok.d.ts'

const props = defineProps({
  blok: {
    type: Object as PropType<SbAssetImage>,
    default: () => {},
  },
  optimiseDesktop: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  cover: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  lazy: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  imageClass: {
    type: [String, undefined] as PropType<string | undefined>,
    default: undefined,
  },
})

const instance = getCurrentInstance()
const { isMobile } = useDeviceType()
const { marginClasses } = useStoryblokMargins(props.blok)
const cmsParentBlok = computed(
  () =>
    ((instance as any)?.parent?.props?.blok as
      | BaseStoryblokComponent
      | undefined) || null,
)

const image = computed(() =>
  isMobile.value && props.blok.imageMobile?.filename
    ? props.blok.imageMobile
    : props.blok.image,
)
</script>
